var map = {
	"./cop28-de": 333,
	"./cop28-de.json": 333,
	"./cop28-en": 334,
	"./cop28-en.json": 334,
	"./cop28-es": 335,
	"./cop28-es.json": 335,
	"./cop28-ja": 336,
	"./cop28-ja.json": 336,
	"./cop28-ko": 337,
	"./cop28-ko.json": 337,
	"./eu-emissions-focus-de": 338,
	"./eu-emissions-focus-de.json": 338,
	"./eu-emissions-focus-en": 339,
	"./eu-emissions-focus-en.json": 339,
	"./eu-emissions-focus-es": 340,
	"./eu-emissions-focus-es.json": 340,
	"./eu-emissions-focus-ja": 341,
	"./eu-emissions-focus-ja.json": 341,
	"./eu-emissions-focus-ko": 342,
	"./eu-emissions-focus-ko.json": 342,
	"./footer-de": 212,
	"./footer-de.json": 212,
	"./footer-en": 213,
	"./footer-en.json": 213,
	"./footer-es": 214,
	"./footer-es.json": 214,
	"./footer-ja": 215,
	"./footer-ja.json": 215,
	"./footer-ko": 216,
	"./footer-ko.json": 216,
	"./foresight-de": 343,
	"./foresight-de.json": 343,
	"./foresight-en": 344,
	"./foresight-en.json": 344,
	"./foresight-es": 345,
	"./foresight-es.json": 345,
	"./foresight-ja": 346,
	"./foresight-ja.json": 346,
	"./foresight-ko": 347,
	"./foresight-ko.json": 347,
	"./gas-crisis-de": 348,
	"./gas-crisis-de.json": 348,
	"./gas-crisis-en": 349,
	"./gas-crisis-en.json": 349,
	"./gas-crisis-es": 350,
	"./gas-crisis-es.json": 350,
	"./gas-crisis-ja": 351,
	"./gas-crisis-ja.json": 351,
	"./gas-crisis-ko": 352,
	"./gas-crisis-ko.json": 352,
	"./marketing-de": 217,
	"./marketing-de.json": 217,
	"./marketing-en": 218,
	"./marketing-en.json": 218,
	"./marketing-es": 219,
	"./marketing-es.json": 219,
	"./marketing-ja": 220,
	"./marketing-ja.json": 220,
	"./marketing-ko": 221,
	"./marketing-ko.json": 221,
	"./oil-shock-de": 353,
	"./oil-shock-de.json": 353,
	"./oil-shock-en": 354,
	"./oil-shock-en.json": 354,
	"./oil-shock-es": 355,
	"./oil-shock-es.json": 355,
	"./oil-shock-ja": 356,
	"./oil-shock-ja.json": 356,
	"./oil-shock-ko": 357,
	"./oil-shock-ko.json": 357,
	"./pages-de": 225,
	"./pages-de.json": 225,
	"./pages-en": 226,
	"./pages-en.json": 226,
	"./pages-es": 227,
	"./pages-es.json": 227,
	"./pages-ja": 228,
	"./pages-ja.json": 228,
	"./pages-ko": 229,
	"./pages-ko.json": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 582;